import { datadogRum } from '@datadog/browser-rum';
import { DD_LOGS_CONSTS } from 'common/constants/constants';

declare global {
  interface Window {
    DD_LOGS: any;
  }
}

const isProd = window.location.hostname === 'app.linearb.io';

export function initRum() {
  if (isProd) {
    let [version] = (process.env.REACT_APP_TAG ?? '').split(' - ');
    version = version.replace('tags/', '');
    const clientToken = process.env.REACT_APP_DD_RUM_CLIENT_TOKEN;
    const applicationId = process.env.REACT_APP_DD_RUM_APP_ID;

    datadogRum.init({
      clientToken,
      applicationId,
      site: 'datadoghq.com',
      service: 'linearb-prod',
      env: 'prod',
      version,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 20,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input'
    });

    datadogRum.startSessionReplayRecording();
  }
}

export function setRumUser(
  userId: number,
  email: string,
  attrs: Record<string, unknown>
) {
  if (isProd) {
    datadogRum.setGlobalContextProperty('account_id', userId);
    datadogRum.setGlobalContextProperty('email', email);

    Object.entries(attrs).forEach(([key, value]) =>
      datadogRum.setGlobalContextProperty(key, value)
    );
  }
}

export function setRumOrganization(organization: Record<string, any> = {}) {
  if (!organization) {
    window.DD_LOGS &&
      window.DD_LOGS.logger.warn(
        DD_LOGS_CONSTS.datadogEvents.setRumOrganizationFailed,
        { organization }
      );

    return;
  }
  if (isProd) {
    const attrs = {
      org: organization.name,
      org_id: organization.id,
      org_license: organization.license.plan_tier_type,
      org_license_expiration: organization.license.end_date,
      plan_name: organization.license.plan_name
    };

    Object.entries(attrs).forEach(([key, value]) =>
      datadogRum.setGlobalContextProperty(key, value)
    );
  }
}
